import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO/SEO';
import { ServiceSchema, BreadcrumbSchema } from '../components/SEO/StructuredData';
import ServicePage from '../components/ServicePage/ServicePage';

// Import Access Control images
import entranceManagementImage from '../assets/images/services/it/ENTRANCE MANAGEMENT.jpg';

// Import IT Security video (can be reused for Access Control)
import itVideo from '../assets/videos/services/IT_Security.mp4';

// Import benefits image
import accessControlBenefitsImage from '../assets/images/services/it/ENTRANCE MANAGEMENT.jpg';

const AccessControlPage: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <SEO title="Access Control Systems" description="Biometric access control and entrance management systems in DRC. Secure your premises with Cool & Care's access solutions." keywords="access control DRC, biometric systems, entrance management, security access Kinshasa" />
      <ServiceSchema name="Access Control Systems" description="Biometric access control and entrance management systems for secure premises." url="/access-control" />
      <BreadcrumbSchema items={[{ name: 'Services', url: '/services' }, { name: 'Access Control', url: '/access-control' }]} />
      <ServicePage
        serviceName={t('servicePage.services.accessControl.name')}
      serviceDescription={t('servicePage.services.accessControl.description')}
      videoUrl={itVideo}
      productImages={[
        entranceManagementImage
      ]}
      features={t('servicePage.services.accessControl.features', { returnObjects: true }) as string[]}
      benefits={t('servicePage.services.accessControl.benefits', { returnObjects: true }) as string[]}
      benefitsImage={accessControlBenefitsImage}
    />
    </>
  );
};

export default AccessControlPage;
